// Components Import
import DocumentStatusBoard from "./DocumentStatusBoard";
import ProductPerformance from "./ProductPerformance";
import DealPerformance from "./DealPerformance";
import DocTypesChart from "./DocTypesChart";
import PipelineOverview from "./PipelineOverview";
import TableChartWrapper from "./TableChartWrapper";

// Components Export
export {
  DocumentStatusBoard,
  DealPerformance,
  DocTypesChart,
  ProductPerformance,
  TableChartWrapper,
  PipelineOverview,
};



// WEBPACK FOOTER //
// ./src/components/DashboardWrapper/index.js